import { Fragment } from "react";
import { ChevronRight } from "lucide-react";
import { LocaleLink } from "@/components/site/LocaleLink";

export type Crumb = {
  label: string;
  /** Absolute path (without /bg prefix). Omit on the current page. */
  to?: string;
};

type Props = {
  items: Crumb[];
  className?: string;
};

export function Breadcrumbs({ items, className }: Props) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={
        "text-[12.5px] leading-none text-muted-foreground " + (className ?? "")
      }
    >
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <Fragment key={`${item.label}-${i}`}>
              <li className="flex items-center">
                {item.to && !isLast ? (
                  <LocaleLink
                    to={item.to}
                    className="transition-colors hover:text-accent"
                  >
                    {item.label}
                  </LocaleLink>
                ) : (
                  <span aria-current={isLast ? "page" : undefined} className="text-foreground/80">
                    {item.label}
                  </span>
                )}
              </li>
              {!isLast && (
                <li aria-hidden className="flex items-center text-muted-foreground">
                  <ChevronRight className="h-3.5 w-3.5" />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}